import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { IconProp, SizeProp } from '@fortawesome/fontawesome-svg-core';

import { StackIconsComponent } from '@connect-services/client/components/stack-icons/stack-icons.component';
import { RessourcesModule } from '@ressources/client/ressources.module';

type FaTransform = string;

export enum LabelIconPosition {
    END = 'end',
    START = 'start',
}

export enum LabelBadgeVariant {
    DANGER = 'danger',
    PRIMARY = 'primary',
}

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RessourcesModule, StackIconsComponent],
    selector: 'app-label-badge',
    styleUrl: './label-badge.component.scss',
    templateUrl: './label-badge.component.html',
})
export class LabelBadgeComponent {
    public readonly baseIcon = input<IconProp | undefined>();
    public readonly baseIconTransform = input<FaTransform>('shrink-2');
    public readonly canClose = input<boolean>(false);
    public readonly close = output<void>();
    public readonly iconPosition = input<LabelIconPosition>(LabelIconPosition.START);
    public readonly iconSize = input<SizeProp>('lg');
    public readonly label = input<string>();
    public readonly tooltip = input<string | undefined>();
    public readonly topIcon = input<IconProp | undefined>();
    public readonly topIconTransform = input<FaTransform>('shrink-6 up-3 right-3');
    public readonly variant = input<LabelBadgeVariant>(LabelBadgeVariant.PRIMARY);

    protected readonly hasLabel = computed<boolean>(() => !!this.label());
    protected readonly LabelIconPosition = LabelIconPosition;
}
